module.exports = __webpack_public_path__ + "static/media/be.5739940d.svg";